import { render, staticRenderFns } from "./MarketChart.vue?vue&type=template&id=505a4e8a&scoped=true"
import script from "./MarketChart.vue?vue&type=script&lang=js"
export * from "./MarketChart.vue?vue&type=script&lang=js"
import style0 from "./MarketChart.vue?vue&type=style&index=0&id=505a4e8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505a4e8a",
  null
  
)

export default component.exports